export default "__VITE_ASSET__B5eGL24m__"